import { IMapMarkerStyleOptions } from '@lib/geo/map';
import { COLORS } from '@lib/ui/theme';

export const ICON_ONLY: IMapMarkerStyleOptions = {
  fillColor: COLORS['base-800'],
  strokeColor: COLORS['grey-400'],
  strokeWeight: 0,
  fillOpacity: 0,
  strokeOpacity: 0,
  scale: 1.2,
};

export const FUSUS_GREEN_ICON_WITH_BORDER: IMapMarkerStyleOptions = {
  fillColor: '#1C2133',
  strokeColor: 'rgb(102, 189, 77)',
  strokeWeight: 1,
  fillOpacity: 1,
  strokeOpacity: 1,
  scale: 1.2,
};
